import React, { useEffect, useState } from "react";
import "./Wishlist.css";
import Header from "../../Components/Header/Header";
import { useNavigate } from 'react-router-dom';
import { getWishist, deleteWishlist, getCartist, updatepassword, getcartwishlistcount, addToCart } from "../../redux/services/productService"; // adjust path if needed
import ShopBanner from "../../Components/Banner/Banner";
import BottomNavigation from "../../Components/BottomMenu/BottomNavigation";
import Swal from "sweetalert2";
import { encrypt } from '../../redux/services/encryptionUtils';
import withReactContent from 'sweetalert2-react-content';
import banner1 from "../../assets/images/banner1.png"
import SearchHeader from "../../Components/Header/SearchHeader";
import HeaderDummy from "../../Components/Header/HeaderDummy";
import { ShoppingCart } from "lucide-react";
import { showError } from "../../utils/alert";
const Wishlist = () => {
  const [wishlist, setWishlist] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);
  const [wishlistTrigger, setWishlistTrigger] = useState(0);
  const [userId, setUserId] = useState(null);
  const [cartTrigger, setCartTrigger] = useState(0);
  const [cartwishlistCount, setCartwishlistCount] = useState({CartCount:0,WishlistCount:0,CartAmount:0});
  const navigate = useNavigate();

    const [isLowEndDevices, setIsLowEndDevices] = useState(window.innerWidth <= 950);
  
    useEffect(() => {
    const handleResize = () => setIsLowEndDevices(window.innerWidth <= 950);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  useEffect(() => {
          window.scrollTo(0, 0);
        }, []);

        useEffect(() => {
          const storedData = localStorage.getItem('userData');
        
          if (storedData) {
            let parsedData = JSON.parse(storedData);
        
            // Check if parsedData is still a string (double stringified case)
            if (typeof parsedData === 'string') {
              parsedData = JSON.parse(parsedData);
            }
        
            if (parsedData && parsedData[0]?.UserId) {
              setUserId(parsedData[0].UserId);
            }
          }
        }, []);

  useEffect(() => {
    const fetchWishlist = async () => {
      try {
        const res = await getWishist();
        if (res.status === 'Success') {
          const parsedResult = JSON.parse(res.result);
          setWishlist(parsedResult.Data || []);
        } else if (res.message === 'WishList Records not Found') {
          setWishlist([]);
        } else {
          console.error("Error fetching wishlist:", res.message);
          setWishlist([]);
        }
      } catch (error) {
        console.error("Error fetching wishlist:", error);
        setWishlist([]);
      } finally {
        setLoading(false);
      }
    };

    fetchWishlist();
  }, [refresh]); // triggers refetch whenever 'refresh' changes

  const handleDeleteWishlist = async (transId) => {
    try {
      await deleteWishlist(transId);
      // Toggle refresh to trigger useEffect
      setRefresh((prev) => !prev);
      setWishlistTrigger(prev => prev + 1);
    } catch (err) {
      console.error("Error removing wishlist item:", err);
    }
  };
  // useEffect(() => {
  //   const fetchCart = async () => {
  //     try {
  //       const res = await getCartist();
  //       const parsedResult = JSON.parse(res.result);
  //       if (parsedResult?.Data) {
  //         const mappedItems = parsedResult.Data.map((item, index) => ({
  //           id: item.TransId || index,
  //           transId: item.TransId,
  //           productId: item.Product, // important for matching
  //           name: item.Product_Name || "Unnamed Product",
  //           price: item.Rate || 0,
  //           quantity: item.Quantity || 1,
  //           image: "/api/placeholder/60/60",
  //         }));
  //         const totalQuantity = mappedItems.reduce((sum, item) => sum + (item.quantity || 1), 0);
  //         setCartItems(mappedItems);
  //         setCartCount(mappedItems.length);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching cart:", error);
  //     }
  //   };

  //   fetchCart();
  // }, []);
 useEffect(() => {
       const fetchCartWishlistCount = async () => {
         try {
           const res = await getcartwishlistcount({BE:1});
           if(res?.status =="Success"){
             const parsedResult = JSON.parse(res.result);
             
             setCartwishlistCount(parsedResult[0]);
           }
           else{
             setCartwishlistCount({});
           }
           
         } catch (error) {
           console.error("Error fetching wishlist:", error);
           setCartwishlistCount({});
         }
       };
   
       fetchCartWishlistCount();
     }, [wishlistTrigger,cartTrigger]);
  const handleLogout = () => {
    // Clear all authentication data
    localStorage.removeItem("authToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("accessToken")
    localStorage.removeItem('refreshToken');

    navigate(`/login`);
  };
  const handleProductView = (product) => {
    navigate('/view', { state: { product, from: 'wishlist' } });
  };

  const MySwal = withReactContent(Swal);
  setTimeout(() => {
  if (window.innerWidth < 400) {
    document.querySelectorAll(".eye-icon").forEach(el => {
      el.style.display = "none";
    });
  }
}, 50);

  const showResetPasswordAlert = async () => {
    const { value: formValues } = await MySwal.fire({
      title: "Reset Password",
      html: `
      <div class="password-input-container">
  <input type="password" id="oldPassword" class="password-swal-input" placeholder="Old Password" autoComplete="new-password" maxlength="30">
  <span class="password-eye-icon password-open-eye" data-target="oldPassword">
    <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24" fill="#555"><path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5C21.27 7.61 17 4.5 12 4.5zm0 12a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9zm0-7a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"/></svg>
  </span>
  <span class="password-eye-icon password-close-eye" data-target="oldPassword" style="display:none;">
    <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24" fill="#555"><path d="M12 6a9.77 9.77 0 0 1 9 6 9.77 9.77 0 0 1-9 6 9.77 9.77 0 0 1-9-6 9.77 9.77 0 0 1 9-6m0-2C6.5 4 1.73 7.11 0 12c1.73 4.89 6.5 8 12 8s10.27-3.11 12-8c-1.73-4.89-6.5-8-12-8Zm5.59 11.41L14.17 12l3.42-3.41L16 7l-4 4-4-4-1.41 1.59L9.83 12l-3.42 3.41L8 17l4-4 4 4 1.59-1.59Z"/></svg>
  </span>
</div>

<div class="password-input-container">
  <input type="password" id="newPassword" class="password-swal-input" placeholder="New Password" maxlength="30">
  <span class="password-eye-icon password-open-eye" data-target="newPassword">
    <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24" fill="#555"><path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5C21.27 7.61 17 4.5 12 4.5zm0 12a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9zm0-7a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"/></svg>
  </span>
  <span class="password-eye-icon password-close-eye" data-target="newPassword" style="display:none;">
    <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24" fill="#555"><path d="M12 6a9.77 9.77 0 0 1 9 6 9.77 9.77 0 0 1-9 6 9.77 9.77 0 0 1-9-6 9.77 9.77 0 0 1 9-6m0-2C6.5 4 1.73 7.11 0 12c1.73 4.89 6.5 8 12 8s10.27-3.11 12-8c-1.73-4.89-6.5-8-12-8Zm5.59 11.41L14.17 12l3.42-3.41L16 7l-4 4-4-4-1.41 1.59L9.83 12l-3.42 3.41L8 17l4-4 4 4 1.59-1.59Z"/></svg>
  </span>
</div>

<div class="password-input-container">
  <input type="password" id="confirmPassword" class="password-swal-input" placeholder="Confirm Password" maxlength="30">
  <span class="password-eye-icon password-open-eye" data-target="confirmPassword">
    <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24" fill="#555"><path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5C21.27 7.61 17 4.5 12 4.5zm0 12a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9zm0-7a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"/></svg>
  </span>
  <span class="password-eye-icon password-close-eye" data-target="confirmPassword" style="display:none;">
    <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 24 24" fill="#555"><path d="M12 6a9.77 9.77 0 0 1 9 6 9.77 9.77 0 0 1-9 6 9.77 9.77 0 0 1-9-6 9.77 9.77 0 0 1 9-6m0-2C6.5 4 1.73 7.11 0 12c1.73 4.89 6.5 8 12 8s10.27-3.11 12-8c-1.73-4.89-6.5-8-12-8Zm5.59 11.41L14.17 12l3.42-3.41L16 7l-4 4-4-4-1.41 1.59L9.83 12l-3.42 3.41L8 17l4-4 4 4 1.59-1.59Z"/></svg>
  </span>
</div>
    `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Submit",
      cancelButtonText: "Close",
      reverseButtons: true,
      customClass: {
        confirmButton: "next-btn2",
      },
      preConfirm: () => {
        const oldPassword = document.getElementById("oldPassword").value;
        const newPassword = document.getElementById("newPassword").value;
        const confirmPassword = document.getElementById("confirmPassword").value;

        if (!oldPassword) {
          Swal.showValidationMessage("Old Password is required");
          return false;
        }
        if (!newPassword) {
          Swal.showValidationMessage("New password is required");
          return false;
        } 
        if (!/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,}$/.test(newPassword)) {
          Swal.showValidationMessage("Password must be at least 6 characters long and include at least one letter, one number, and one special character.");
          return false;
        }
        if (!confirmPassword) {
          Swal.showValidationMessage("Confirm password is required");
          return false;
        }

        if (newPassword !== confirmPassword) {
          Swal.showValidationMessage("Passwords do not match");
          return false;
        }

        return { oldPassword, newPassword };
      },
      didOpen: () => {
        const inputs = document.querySelectorAll(".custom-swal-input");
        inputs.forEach((input) => {
          input.style.fontSize = "14px";
          input.style.paddingRight = "40px";
        });

        // Eye toggle functionality
       document.querySelectorAll('.password-eye-icon').forEach(icon => {
  icon.addEventListener('click', function() {
    const targetId = this.getAttribute('data-target');
    const passwordInput = document.getElementById(targetId);
    const openEye = this.classList.contains('password-open-eye');
    const closeEye = this.classList.contains('password-close-eye');
    
    if (openEye) {
      // Switch to text (visible)
      passwordInput.type = 'text';
      this.style.display = 'none';
      document.querySelector(`.password-close-eye[data-target="${targetId}"]`).style.display = 'block';
    } else if (closeEye) {
      // Switch to password (hidden)
      passwordInput.type = 'password';
      this.style.display = 'none';
      document.querySelector(`.password-open-eye[data-target="${targetId}"]`).style.display = 'block';
    }
  });
});
      },
    });

    if (formValues) {
      try {
        const encryptedOldPassword = await encrypt(formValues.oldPassword);
        const encryptedPassword = await encrypt(formValues.newPassword);

        const postData = {
          oldPassword: encryptedOldPassword,
          newPassword: encryptedPassword,
        };

        const response = await updatepassword(postData);

        if (response.status === "Success") {
          await MySwal.fire("Success", "Password has been updated successfully!", "success");
        } else {
          await MySwal.fire("Error", response.message || "Failed to update password", "error");
        }
      } catch (error) {
        console.error("Reset Password Error:", error);
      }
    }
  };
    const handleAddToCart = async (product) => {
   
    
      if (product.Stock === 0 || product.Stock === 0.0) {
        showError("Product is out of stock. Please try after the stock update.");
        return;
      }
    //    if (product.Rate == 0 ) {
        
    //   showError("This product cannot be added to the cart because its price is not available");
    //   return;
    // }
      try {
        const payload = {
          transId: 0,
          date: new Date().toISOString().split("T")[0],
          customer: userId,
          warehouse: 2,
          remarks: "",
          discountType: 1,
          discountCouponRef: "ref01",
          discountRef: "Ref809",
          sampleRequestedBy: 1,
          product: product.Id,
          qty: 1,
          rate: product.Rate || 0,
          unit: 1,
          totalRate: product.Rate || 0,
          addCharges: 0,
          discount: 0,
          discountAmt: 0,
          discountRemarks: "",
          be: 0,
        };
        await addToCart(payload);
       
       
    
        setCartTrigger(prev => prev + 1); // Trigger cart count refresh
      } catch (err) {
        console.error("Error adding to cart:", err);
      }
    };


  return (
    <>
      {isLowEndDevices ? (
  <>

      <Header />
       <SearchHeader
        cartwishlistCount={cartwishlistCount}
        categories={[]}
        selectedCategory={null}
        cartTrigger={cartTrigger}
        wishlistTrigger={wishlistTrigger}
        otherScreens={true}
         />
     </>) : (
  <>
        <HeaderDummy/>
    <SearchHeader
        cartwishlistCount={cartwishlistCount}
        categories={[]}
        selectedCategory={null}
        cartTrigger={cartTrigger}
        wishlistTrigger={wishlistTrigger}
        otherScreens={true}
         />
    <Header />
  </>
)} 
      <ShopBanner
        header=""                                    // top-left blue title
        badgeText="Wishlist"                                // small orange badge text
        subheader=""                 // big subheader inside banner
        backgroundImage={banner1}   // relative or absolute URL to background
        height="60px"                                // banner height (optional)
      />
      <div className="wishlist-container" style={{paddingBottom:"50px"}}>
        {/* Header */}


        {/* Breadcrumb */}
        {/* <div className="breadcrumb">
          <span className="breadcrumb-item" onClick={() => navigate('/home')}>HOME</span>
          <span className="separator">/</span>
          <span>WISHLIST</span>
        </div> */}

        <div className="wishlist-content" style={{paddingTop:"5px"}}>
          {/* Left Sidebar */}
          <div className="wishlist-sidebar">
            <h1 className="orders-account-title">MY ACCOUNT</h1>
            <nav className="orders-nav-menu2">
              {/* <a href="#" className="orders-nav-item">Dashboard</a> */}
              <a href="#" className="orders-nav-item " onClick={() => navigate('/account')}>Orders</a>
              {/* <a href="#" className="orders-nav-item">Downloads</a>
            <a href="#" className="orders-nav-item">Addresses</a>
            <a href="#" className="orders-nav-item">Account details</a>
            <a href="#" className="orders-nav-item">Buy again</a> */}
              <a href="#" className="orders-nav-item orders-active" >Wishlist</a>
              <a href="#" className="orders-nav-item orders-logout-item" onClick={showResetPasswordAlert}>
                Reset Password
              </a>
              <a href="#" className="orders-nav-item orders-logout-item" onClick={handleLogout}>
                Logout
              </a>
            </nav>
          </div>

          {/* Main Content */}
          <div className="main-content">
            <div className="wishlist-header-section">
              <h3 className="section-title" style={{fontSize:"16px"}}>YOUR PRODUCTS WISHLIST</h3>
        
            </div>

            {/* Product Grid */}
            <div className="product-grid">
              {loading ? (
                <p>Loading wishlist...</p>
              ) : wishlist.length === 0 ? (
                <p>No products in your wishlist.</p>
              ) : (
                wishlist.map((item) => (
                  <div key={item.TransId} className="product-card-shop">
                    <button
                      className="remove-btn2"
                      onClick={() => handleDeleteWishlist(item.TransId)}
                    >
                      ✕
                    </button>

                   <div className="product-imageShop" onClick={() => handleProductView(item)}>
                    <img src={item.Image} alt={item.Name}  onClick={() => handleProductView(item)} loading="lazy"/>
                  </div>
                      <div className="product-actions">
                    {/* {inCart ? (
                      <button className="added-btn">✅ In Cart</button>
                    ) : ( */}
                      <button
                        className="overlay-btn"
                        onClick={() => handleAddToCart(item)}
                      >
                        <ShoppingCart size={20} style={{
                          transform: "scaleX(-1)",   // FLIP horizontally
                          transformOrigin: "center"
                        }} />
                      </button>
                    {/* )} */}

                 
                  </div>
                     <div className="product-info-shop" onClick={() => handleProductView(item)}>
                    <h3 className="product-name" >{item.Name}</h3>
                    {/* <p className="product-description" >{product?.CategoryName }</p> */}
                    <p className="product-description2" >{item?.SubCategoryName}</p>
                    <div className="product-price" >
                      {item.sale ? (
                        <>
                          {/* <span className="original-price">
                            AED{(product?.Rate + 20).toFixed(2)}
                          </span> */}
                          <span className="sale-price" style={{marginBottom:"0px"}}>{(item?.Rate ?? 0).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })} AED</span>
                        </>
                      ) : (
                        <span className="sale-price" style={{marginBottom:"0px"}}>{(item?.Rate ?? 0).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })} AED</span>
                      )}
                    </div>
                    {/* <button
                      className="enlarge-btn"
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent opening popup when clicking enlarge
                        setSelectedProduct(product);
                        setShowPopup(true);
                      }}
                    >
                      <Maximize size={18} />Click to Enlarge
                    </button> */}
                  </div>
                  </div>
                ))
              )}
            </div>

          </div>
        </div>

       
        <BottomNavigation
          cartCount={cartwishlistCount?.CartCount}
          wishlistCount={cartwishlistCount?.WishlistCount}
          onCartUpdate={() => setCartTrigger(prev => prev + 1)}

        />

        {/* Chat Button */}
        {/* <div className="chat-button">
          <span className="chat-text">Chat with us</span>
        </div> */}
      </div>
    </>
  );
};

export default Wishlist;
